module.exports = __webpack_public_path__ + "97318cc9b87c952976f5034aab5cd02c.MP3";